import { render, staticRenderFns } from "./ReplaceItemOverlay.vue?vue&type=template&id=3bddff6e&scoped=true"
import script from "./ReplaceItemOverlay.vue?vue&type=script&lang=js"
export * from "./ReplaceItemOverlay.vue?vue&type=script&lang=js"
import style0 from "./ReplaceItemOverlay.vue?vue&type=style&index=0&id=3bddff6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bddff6e",
  null
  
)

export default component.exports